export const toFixed2 = (value) => {
  const num = parseFloat(value);
  return isNaN(num) ? '—' : num.toFixed(2);
};

export const toSlug = (value) =>
  (value ?? '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
